import styled from "styled-components"

import { Flex, FlexColumn, Box } from "components/box"
import { BorderBox } from "components/page-elements"
import { ParagraphSmall, ParagraphLarge, LinkWithArrow } from "components/text"

const Container = styled(BorderBox).attrs({
  my: 4,
  py: [4, 4, 5, 5],
  px: [2, 2, 7, 7]
})`
  flex-direction: row;
  align-items: center;
`

const Content = styled(FlexColumn)`
  align-items: stretch;
  flex-basis: 80%;
  text-align: left;
  margin: ${props => props.theme.space[4]};
  cursor: pointer;
`

const Title = styled(ParagraphSmall)`
  letter-spacing: 1.75px;
  text-transform: uppercase;
  font-weight: bold;
`

const Count = styled(ParagraphLarge)`
  font-size: 64px;
  margin-right: ${props => props.theme.space[4]};
`

const Link = styled(LinkWithArrow)`
  text-decoration: none;
`

const RoundIcon = styled(Flex)`
  position: relative;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  background-color: ${props => props.theme.colors.paleAqua};
  border-radius: 50%;
  margin-bottom: ${props => props.theme.space[3]};
`

const IconContainer = styled(FlexColumn)`
  justify-content: center;
  align-items: center;
  flex-basis: 20%;
  padding-left: ${props => props.theme.space[5]};
  margin: ${props => props.theme.space[4]};

  :hover {
    cursor: pointer;
  }
`

const NotificationIndicator = styled(Box)`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  background-color: ${props => props.theme.colors.sandy};
  border-radius: 50%;
`
export const DashboardCard = {
  Container,
  Content,
  Title,
  Count,
  Link,
  IconContainer,
  RoundIcon,
  NotificationIndicator
}
